import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=c711dc8c&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=c711dc8c&lang=scss&scoped=true&"
import style1 from "./CategoryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c711dc8c",
  null
  
)

export default component.exports